module.exports = __webpack_public_path__ + "4841441f490fffee9bdd08c60a77ec7b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/university_notre_dame_2023_chart.png
// module id = 1754
// module chunks = 0